/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publish_To_IconikInputs */

const en_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish work to Iconik`)
};

const fr_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier sur Iconik`)
};

const de_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichen Sie Ihre Arbeit auf Iconik`)
};

const it_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblica il lavoro su Iconik`)
};

const ru_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовать работу в Iconik`)
};

const es_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar trabajo en Iconik`)
};

const zh_cn2_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将作品发布到 Iconik`)
};

const ja_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconikに作品を公開する`)
};

const hi_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik पर अपना काम प्रकाशित करें`)
};

const pt_pt2_publish_to_iconik = /** @type {(inputs: Publish_To_IconikInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publique seu trabalho na Iconik.`)
};

/**
* | output |
* | --- |
* | "Publish work to Iconik" |
*
* @param {Publish_To_IconikInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const publish_to_iconik = /** @type {((inputs?: Publish_To_IconikInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publish_To_IconikInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_publish_to_iconik(inputs)
	if (locale === "de") return de_publish_to_iconik(inputs)
	if (locale === "it") return it_publish_to_iconik(inputs)
	if (locale === "ru") return ru_publish_to_iconik(inputs)
	if (locale === "es") return es_publish_to_iconik(inputs)
	if (locale === "zh-CN") return zh_cn2_publish_to_iconik(inputs)
	if (locale === "ja") return ja_publish_to_iconik(inputs)
	if (locale === "hi") return hi_publish_to_iconik(inputs)
	if (locale === "pt-PT") return pt_pt2_publish_to_iconik(inputs)
	return en_publish_to_iconik(inputs)
});